import { format } from 'date-fns';
import dayjs from 'dayjs';
// modals
import DialogModal from 'components/modal/dialog-modal';
// iocns
import SuccessIcom from 'assets/icons/buttons/success-button.svg';
// redux
import { useGetCurrentPaymentPlanQuery } from 'redux-store/api/billing';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { billingSelector } from 'redux-store/selector';
import { setSubscribedPlanInfo } from 'redux-store/slices/billing-slice';
// MUI
import { LoadingButton } from '@mui/lab';
import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
// styles
import { useGetPlansQuery } from 'redux-store/api/billing';
import { subscribedPlanInfoStyles } from './styles';
// types
import { useMemo } from 'react';
import { PaymentPlanRecurrings } from 'utils/types';

const SubscriptionNotificationModal = () => {
  const dispatch = useAppDispatch();

  const { subscribedPlanInfo } = useAppSelector(billingSelector);
  const { data: currentPlan } = useGetCurrentPaymentPlanQuery();

  const handleClose = () => {
    dispatch(setSubscribedPlanInfo({ plan: null, isSubscribed: false }));
  };

  const { data: paymentPlans } = useGetPlansQuery();

  const isCouponValid = paymentPlans?.items?.find(
    (item) => item.recurring === PaymentPlanRecurrings.Monthly
  )?.couponCode?.code;

  const openModal = useMemo(
    () =>
      subscribedPlanInfo &&
      currentPlan &&
      currentPlan.transaction &&
      subscribedPlanInfo?.isSubscribed &&
      subscribedPlanInfo.plan.companyId === currentPlan.transaction.companyId,
    [subscribedPlanInfo, currentPlan]
  );

  return (
    <DialogModal
      open={openModal}
      maxWidth="420px"
      withCloseButton={false}
      handleClose={handleClose}
    >
      <SuccessIcom />
      <Typography sx={subscribedPlanInfoStyles.modalTitle}>
        You are now subscribed to the
      </Typography>
      <Typography sx={subscribedPlanInfoStyles.planName}>
        {subscribedPlanInfo?.plan?.productName}
      </Typography>

      {currentPlan?.recurring !== PaymentPlanRecurrings.OneTime && (
        <Box>
          <Box sx={subscribedPlanInfoStyles.chargingText}>
            <Typography sx={subscribedPlanInfoStyles.subtitle}>You will be charged: </Typography>
            <Typography sx={subscribedPlanInfoStyles.subtitleValue}>
              $
              {isCouponValid && subscribedPlanInfo?.plan?.period === PaymentPlanRecurrings.Monthly
                ? Math.floor((subscribedPlanInfo?.plan?.amount * (100 - 30)) / 10000)
                : Math.round(subscribedPlanInfo?.plan?.amount / 100)}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Typography sx={subscribedPlanInfoStyles.subtitle}>Starting on: </Typography>
            <Typography sx={subscribedPlanInfoStyles.subtitleValue}>
              {currentPlan?.nextBillingDate && dayjs().isAfter(currentPlan.nextBillingDate)
                ? format(new Date(), 'MM/dd/yy')
                : currentPlan?.nextBillingDate
                  ? format(new Date(currentPlan.nextBillingDate), 'MM/dd/yy')
                  : ''}
            </Typography>
          </Box>
        </Box>
      )}

      <Grid sx={subscribedPlanInfoStyles.doneBox}>
        <LoadingButton onClick={handleClose} sx={subscribedPlanInfoStyles.doneButtonStyles}>
          Donе
        </LoadingButton>
      </Grid>
    </DialogModal>
  );
};

export default SubscriptionNotificationModal;
